import { type ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  noBottomPadding?: boolean;
  /** Enable flex column layout for the container */
  flexColumn?: boolean;
}

export function PageContainer({
  children,
  className = '',
  noPadding = false,
  noBottomPadding = false,
  flexColumn = false,
}: PageContainerProps) {
  return (
    <main
      id="main-content"
      className={`
        min-h-screen flex flex-col
        ${noPadding ? '' : 'px-4 md:px-8 pt-6'}
        ${noBottomPadding ? '' : 'pb-24 md:pb-8'}
        ${className}
      `}
    >
      <div className={`max-w-2xl md:max-w-5xl mx-auto my-auto w-full ${flexColumn ? 'flex-1 flex flex-col' : ''}`}>
        {children}
      </div>
    </main>
  );
}

export default PageContainer;
